export const ASESORIA_FORM = {
    name: "",
    empresa: "",
    phone: "",
};
